module.exports = __webpack_public_path__ + "static/media/nutrients-brown.f2f8fad7.svg";